// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZOj3RSPLvDQsx0oacqlT {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: white;
  font-size: var(--caption);
  white-space: nowrap;
}

._S179I1uWTVHqunf_SFC {
  display: inline;
  padding-left: 6px;
  font-weight: 600;
}

.OsDcjWY527vCJTkQusMw {
  color: #ff6b6b;
}

.SJh8wu60_uV_I37ZQt07 {
  color: lightgreen;
}`, "",{"version":3,"sources":["webpack://./src/components/App/components/AspectStatus.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".aspectHealthOptions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: white;\n  font-size: var(--caption);\n  white-space: nowrap;\n}\n\n.status {\n  display: inline;\n  padding-left: 6px;\n  font-weight: 600;\n}\n\n.error {\n  color: #ff6b6b;\n}\n\n.ok {\n  color: lightgreen;\n}"],"sourceRoot":""}]);
// Exports
export var aspectHealthOptions = `ZOj3RSPLvDQsx0oacqlT`;
export var status = `_S179I1uWTVHqunf_SFC`;
export var error = `OsDcjWY527vCJTkQusMw`;
export var ok = `SJh8wu60_uV_I37ZQt07`;
export default ___CSS_LOADER_EXPORT___;
